import { _js } from '@ifixit/localize';
import { useContext } from 'react';
import { ApiContext } from '../Providers/apiContext';
import { getWorkOrder, getWorkOrderIncident } from './thdWorkOrder';
import { OrderContext } from '../Providers/orderContext';
import { trackAnalyticsCustomEvent, type CustomAnalyticsEvent } from '@ifixit/analytics';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';
import RDModal from './RDModal';
import HDESModal from './HDESModal';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';
import { Button, ButtonProps, useDisclosure } from '@chakra-ui/react';
import { orangeTheme } from './colors';

const OrderPartApiButton = ({
   data,
   ...props
}: {
   data: iFixitHotSpotItem;
} & ButtonProps) => {
   const apiContext = useContext(ApiContext);
   const { isOpen, onOpen, onClose } = useDisclosure();

   if (apiContext.squad == 'Repair Depot' && apiContext.apiKey && getWorkOrder()) {
      return (
         <>
            <OrderRDPartApiButton data={data} onOpen={onOpen} {...props} />
            <RDModal isOpen={isOpen} onClose={onClose} />
         </>
      );
   } else if (
      apiContext.squad == 'HDES' &&
      apiContext.apiKey &&
      getWorkOrder() &&
      getWorkOrderIncident()
   ) {
      return (
         <>
            <OrderHDESPartApiButton data={data} onOpen={onOpen} {...props} />
            <HDESModal isOpen={isOpen} onClose={onClose} />
         </>
      );
   }

   return null;
};

const ApiButton = ({
   data,
   text,
   trackingData,
   onOpen,
   ...props
}: {
   data: iFixitHotSpotItem;
   text: string;
   trackingData: CustomAnalyticsEvent;
   onOpen: MinimalDisclosure['onOpen'];
} & ButtonProps) => {
   const orderContext = useContext(OrderContext);

   const onClick = () => {
      orderContext.setItem(data);
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onOpen();
      trackAnalyticsCustomEvent(trackingData);
   };

   return (
      <Button
         bgColor={orangeTheme.primaryButton}
         color="white"
         _hover={{
            bgColor: orangeTheme.primaryButtonHover,
         }}
         onClick={onClick}
         {...props}
      >
         {text}
      </Button>
   );
};

const OrderRDPartApiButton = ({
   data,
   onOpen,
   ...props
}: {
   tabIndex?: number;
   data: iFixitHotSpotItem;
   onOpen: MinimalDisclosure['onOpen'];
} & ButtonProps) => {
   const wiki = data.wiki;
   const trackingData = {
      eventCategory: 'THDOrder',
      eventAction: 'Order',
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      eventName: `Brand: ${wiki.brand} SKU: ${wiki.sku}`,
   };

   return (
      <ApiButton
         trackingData={trackingData}
         data={data}
         text={_js('Order Part')}
         onOpen={onOpen}
         {...props}
      />
   );
};

const OrderHDESPartApiButton = ({
   tabIndex,
   data,
   onOpen,
   ...props
}: {
   tabIndex?: number;
   data: iFixitHotSpotItem;
   onOpen: MinimalDisclosure['onOpen'];
} & ButtonProps) => {
   const wiki = data.wiki;
   const trackingData = {
      eventCategory: 'THDHDESOrder',
      eventAction: 'Order',
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      eventName: `Brand: ${wiki.brand} SKU: ${wiki.sku}`,
   };

   return (
      <ApiButton
         trackingData={trackingData}
         tabIndex={tabIndex}
         data={data}
         text={_js('Add to Call')}
         onOpen={onOpen}
         {...props}
      />
   );
};

export { OrderPartApiButton };
